export const VERSION_CWA = 'v 6.7.61';
export const VERSION_CWA_NUMBER = '6.7.61';
